import * as React from "react";
const SvgFiRrLacrosseStickBall = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lacrosse-stick-ball_svg__a)">
      <path
        fill="#062147"
        d="M18.892 14.044c1.373-.124 2.58-.673 3.492-1.586 1.227-1.226 1.785-2.954 1.573-4.864-.203-1.828-1.097-3.616-2.516-5.035-2.988-2.989-7.429-3.412-9.899-.943-.914.914-1.462 2.121-1.585 3.493-.08.886-.635 1.757-1.524 2.388-1.962 1.394-2.843 3.829-2.243 6.202.168.666.47 1.284.86 1.838L.292 22.293a.999.999 0 1 0 1.414 1.414l6.756-6.756a5.6 5.6 0 0 0 1.84.859c.494.125.992.186 1.482.186 1.86 0 3.615-.875 4.718-2.429.631-.889 1.502-1.444 2.39-1.523m-4.02.365c-.926 1.305-2.492 1.866-4.08 1.462a3.72 3.72 0 0 1-2.664-2.662c-.402-1.591.158-3.155 1.462-4.081 1.367-.971 2.227-2.371 2.358-3.84.081-.899.43-1.68 1.007-2.258.698-.698 1.648-1.035 2.681-1.035 1.465 0 3.094.681 4.391 1.978 1.1 1.099 1.79 2.463 1.941 3.841.145 1.294-.21 2.441-1 3.23-.576.578-1.357.926-2.257 1.007-1.47.132-2.869.991-3.84 2.357zM20.5 17c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lacrosse-stick-ball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLacrosseStickBall;
